module.exports = __webpack_public_path__ + "static/media/refraction_tomography_1.bb0e0ab6.png";